// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1631":"622a4cbb","1741":"622a4cbb","7894":"622a4cbb","8165":"622a4cbb","9970":"622a4cbb"}[chunkId] + ".chunk.css";
};